import QueryCredits from "graphql/queries/QueryCredits";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder';

const FetchCredits = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'employee_credits', QueryCredits, {
			resultPath: [ 'employee_credits' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}

export default FetchCredits
